module.exports = "/_next/static/images/non-suite-b5bdcf9ef034fea93ef100039bb6130e.svg";